import React from 'react';
import { Button } from 'react-bootstrap';
import { useFieldStore } from '../../providers/FieldProvider';

type Props = {
    fieldCount: number,
    isFiltered: boolean
}

const FieldListHeader = ({fieldCount, isFiltered}: Props) => {
    const { resetFilter } = useFieldStore();

    return (
        <div className="align-items-center border-bottom border-top d-flex justify-content-between px-3 py-2">
            <span className="font-weight-bold text-capitalize text-sm font-weight-bold">{`BLOCKS (${fieldCount})`}</span>
            {
                isFiltered 
                ? <Button className="p-0" variant="link" onClick={(e:any) => resetFilter()}>
                    <span className="text-xs">remove filters</span>
                </Button>
                : ''
            }
        </div>
    );
}

export default FieldListHeader;